export enum NavigationMenuUmbrellaId {
  Customers = 'customers',
  Inbox = 'inbox',
  Roles = 'roles',
  UmbrellaProfile = 'umbrellaProfile',
  UmbrellaSubscriptions = 'umbrellaSubscriptions',
  Users = 'users',
}
